import { render, staticRenderFns } from "./CDRQDirectorView.vue?vue&type=template&id=5c7c8852&scoped=true&"
import script from "./CDRQDirectorView.vue?vue&type=script&lang=ts&"
export * from "./CDRQDirectorView.vue?vue&type=script&lang=ts&"
import style0 from "./CDRQDirectorView.vue?vue&type=style&index=0&id=5c7c8852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c8852",
  null
  
)

export default component.exports